/**
 * GYG Resto365 Foundations — navigation surfaces (aligned with Figma “GYG-RESTO365 - Foundations”).
 * Typography matches Foundations: clean sans, medium menu labels (Inter applied in `bhyveNavFont`).
 */
export const bhyveNavTokens = {
  /** Primary rail background — light gray panel */
  sidebarBg: '#F2F2F2',
  sidebarBorder: '#E4E4E4',
  sidebarText: '#171717',
  sidebarTextMuted: '#616161',

  /** Feature toggle description — readable on light rail (avoid near-white caption) */
  sidebarToggleDescription: 'rgba(23, 23, 23, 0.62)',

  /** Row hover — visible on light gray rail (WCAG-friendly vs 6% fill) */
  sidebarRowHover: 'rgba(23, 23, 23, 0.09)',

  /** Selected row surface */
  sidebarRowActiveBg: '#E4E4E4',

  /** Hover while selected — slightly darker than active alone */
  sidebarRowActiveHoverBg: '#D8D8D8',

  /** Brand */
  brandYellow: '#FFD204',

  /** Profile / header card on rail */
  sidebarHeaderCardBg: '#FFFFFF',
  sidebarHeaderCardBorder: '#E0E0E0',

  /** Secondary bar — top of content; blur when scrolled (see BhyveHorizontalSubnavV2) */
  secondaryBarBg: 'rgba(255, 255, 255, 0.88)',
  secondaryBarBorder: '#E0E0E0',

  /** Active pill: yellow fill + dark text (Figma) */
  pillActiveBg: '#FFD204',
  pillActiveText: '#171717',
  pillInactiveText: '#171717',
  dropdownPaperBg: '#FFFFFF',

  /** Type scale (px) — rail only */
  fontSizeProfileName: 15,
  fontSizeProfileRole: 12,
  fontSizeMenuItem: 14,
  fontSizeSectionLabel: 11,
  fontSizeBackHeader: 14,
  fontWeightMenuItem: 500,
  fontWeightMenuItemActive: 600,
  fontWeightProfileName: 700,
  letterSpacingSection: '0.06em',
  lineHeightTight: 1.25,

  /** Menu list density (Figma: tight vertical rhythm, aligned icon + label) */
  menuRowPaddingY: 6,
  menuRowMinHeight: 36,
  menuIconSize: 22,
  menuIconGutter: 36,
  menuListPaddingY: 4,
  menuChevronSize: 18,

  /** Bottom utility strip — slightly darker than rail so footer reads as its own band */
  sidebarFooterUtilityBg: '#EBEBEB',

  /** Bottom utility strip — four icons, centered, even spacing (Figma) */
  footerUtilityIconSize: 22,
  footerUtilityGap: 3,
  footerUtilityRowPaddingY: 1.25,
  footerUtilityIconTap: 40
} as const
